var app = angular.module('TargetEduOnlineMarking', ['ngRoute', 'ngCookies', 'ngResource', 'ngAnimate', 'toaster', 'angular-loading-bar']);
app.config(function($routeProvider) {
  $routeProvider.when('/', {
    controller: 'Home',
    templateUrl: 'views/home.html'
  })
    .when('/about', {
      templateUrl: 'views/about.html'
    })
    .when('/contact', {
      templateUrl: 'views/contact.html'
    })
    .when('/transcript', {
      controller: 'Transcript',
      templateUrl: 'views/transcript/index.html'
    })
    .when('/login', {
      controller: 'Login',
      templateUrl: 'views/account/login.html'
    })
    .when('/register', {
      controller: 'Register',
      templateUrl: 'views/account/register.html'
    })
    .when('/teacherlogin', {
      controller: 'TeacherLogin',
      templateUrl: 'views/account/teacherlogin.html'
    })
    .when('/teacherregister', {
      controller: 'Register',
      templateUrl: 'views/account/teacherregister.html'
    })
    .when('/tests', {
      controller: 'TeacherTests',
      templateUrl: 'views/account/tests.html'
    })
    .when('/teacherresult/:id', {
      controller: 'TeacherResult',
      templateUrl: 'views/transcript/teacher.html'
    })
    .when('/forgotpw', {
      controller: 'ForgotPW',
      templateUrl: 'views/account/forgotpw.html'
    })
    .when('/bind', {
      controller: 'Bind',
      templateUrl: 'views/account/bind.html'
    })
    .when('/bind/add', {
      controller: 'BindAdd',
      templateUrl: 'views/account/bindAdd.html'
    })
    .when('/profile', {
      controller: 'Profile',
      templateUrl: 'views/account/profile.html'
    })
    .when('/changename', {
      controller: 'ChangeName',
      templateUrl: 'views/account/changename.html'
    })
    .when('/changeschool', {
      controller: 'ChangeSchool',
      templateUrl: 'views/account/changeschool.html'
    })
    .when('/changepw', {
      controller: 'ChangePW',
      templateUrl: 'views/account/changepw.html'
    })
    .when('/survey/test/:testId/student/:student', {
      controller: 'Survey',
      templateUrl: 'views/survey/index.html'
    })
    .when('/scoreboard/student/:hash', {
      controller: 'Scoreboard',
      templateUrl: 'views/transcript/scoreboard.html'
    })
    .when('/memberintro', {
      controller: 'MemberIntro',
      templateUrl: 'views/account/memberintro.html'
    })
    .when('/buy', {
      controller: 'OrderBuy',
      templateUrl: 'views/order/buy.html'
    })
    .when('/pay', {
      controller: 'OrderPay',
      templateUrl: 'views/order/pay.html'
    })
    .when('/bindlog', {
      controller: 'BindLog',
      templateUrl: 'views/account/bindlog.html'
    })
    .when('/complete', {
      templateUrl: 'views/order/complete.html'
    })
    .when('/print/student/:hash', {
      controller: 'Scoreboard',
      templateUrl: 'views/transcript/print.html'
    })
    .when('/detailresult/test/:testId/s/:testnumber', {
      templateUrl: 'views/result/detail.html',
      controller: 'DetailResult'
    })
    .when('/querystudent', {
      templateUrl: 'views/account/student.html',
      controller: 'QueryStudent'
    })
    .when('/404', {
      templateUrl: 'views/404.html'
    })
    .otherwise({
      redirectTo: '/404'
    });
});

// Header format
app.run(function($http) {
  $http.defaults.headers.post['Content-Type'] = 'application/json';
  $http.defaults.headers.put['Content-Type'] = 'application/json';
  $http.defaults.withCredentials = true;
});


// Header param string built from json
app.config(function($httpProvider) {
  $httpProvider.interceptors.push(['$location', '$q', function($location, $q) {
    return {
      'response': function(response) {
        if (response.data.status == 401) {
          console.log("not logged in");
          var loginPage = response.data.data === 1 ? '/teacherlogin' : '/login';
          $location.path(loginPage);
        }
        if (response.data.status == 403) {
          console.log("not authorized");
          $location.url('/403?action=' + response.data.data);
        }
        return response;
      },
      'responseError': function(rejection) {
        console.log("error");
        console.log(response);
      }
    };
  }]);
});

// session service
app.service('appCookie', ['$cookies', '$cookieStore', function($cookies, $cookieStore) {
  this.create = function(data) {
    if (data.mt_id) {
      $cookies.mt_id = data.mt_id;
      $cookies.mt_tel = data.mt_tel;
      $cookies.mt_name = data.mt_name;
      $cookies.mt_sex = data.mt_sex;
      this.destroy();
    } else {
      $cookies.ms_id = data.ms_id;
      $cookies.ms_tel = data.ms_tel;
      $cookies.ms_name = data.ms_name;
      $cookies.ms_sex = data.ms_sex;
      this.destroy(true);
    }
  };
  this.getUser = function() {
    if ($cookies.ms_id) {
      return {
        ms_id: $cookies.ms_id,
        ms_tel: $cookies.ms_tel,
        ms_name: $cookies.ms_name,
        ms_sex: $cookies.ms_sex
      };
    } else if ($cookies.mt_id) {
      return {
        mt_id: $cookies.mt_id,
        mt_tel: $cookies.mt_tel,
        mt_name: $cookies.mt_name,
        mt_sex: $cookies.mt_sex
      };
    } else {
      return null;
    }
  };
  this.destroy = function(isTeacher) {
    if (isTeacher) {
      $cookieStore.remove('mt_id');
      $cookieStore.remove('mt_tel');
      $cookieStore.remove('mt_name');
      $cookieStore.remove('mt_sex');
    } else {
      $cookieStore.remove('ms_id');
      $cookieStore.remove('ms_tel');
      $cookieStore.remove('ms_name');
      $cookieStore.remove('ms_sex');
    }
  };
  return this;
}]);

app.filter('char', function() {
  return function(input) {
    input = input || 0;
    return String.fromCharCode(65 + input);
  };
});

app.factory('CommonFunc', ['toaster', function(toaster) {
  return {
    showToastr: function(result) {
      var toastType = ['error', 'success'];
      var status = toastType[result.status] || 'error';
      toaster.pop(status, result.info);
    }
  };
}]);

// CONSTANTS
app.constant('BASE_URL', window.API_HOST + "/targetedu/index.php/api/");

app.controller('MemberIntro', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc) {
    var search = $location.search();
    $scope.from = search.from;
    $scope.back = function() {
      var path = $scope.from ? '/' + $scope.from : '/';
      $location.path(path);
    };
    $scope.buyLink = device && device.mobile() && navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i) ? window.API_HOST + '/targetedu/index.php/api/wechat' : '#/buy';

    $scope.setCrumb([{
      title: '会员介绍'
    }]);
    $scope.showModalFunc = function(index) {
      $("#modal-" + index).modal("show");
    };

    $scope.list = [{
      title: '名次详情',
      desc: '查询考生总体名次，以及考生名次相较于上一次考试的变化情况（部分七、八年级考试基于当地教育政策规定，不得展示名次）。',
      icon: 'line chart',
      func: 'rank',
      new: true
    }, {
      title: '进步助手',
      desc: '显示考生进步不同名次所需要多考的分数，量化进步指标！',
      icon: 'flag checkered',
      func: 'upgrade',
      new: true
    }, {
      title: '成绩打印',
      desc: '您可以打印每次考试的完整成绩分析报告，方便查看和保存。',
      icon: 'print',
      func: 'print',
      new: true
    }, {
      title: '短信通知',
      desc: '成绩发布后，您将立即收到可以查询成绩的短信通知，考生成绩早知道！',
      icon: 'mail outline',
      new: true
    }, {
      title: '永久档案',
      desc: '您的成绩和考卷图像将永久存放在云存储空间中，可随时进行查看。',
      icon: 'database',
      func: 'image',
      new: true
    }, {
      title: '学科成绩',
      desc: '查询各学科的每小题得分，客观题填涂情况以及参考答案。',
      icon: 'book',
      func: 'course'
    }, {
      title: '分析建议',
      desc: '展示考生考试的优势学科和薄弱学科，以及成绩所在区间。',
      icon: 'law',
      func: 'advice'
    }];
  }
]);

app.controller('Login', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    $scope.params = {};
    appCookie.destroy();
    resApi.logout().$promise.then(function(ret) { });
    var search = $location.search();
    var redirect = search.redirect;

    $scope.setCrumb([{
      title: '学生用户登录'
    }]);

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        resApi.login($scope.params).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          if (ret.status === 1) {
            appCookie.create(ret.data);
            $scope.setUser(appCookie.getUser());
            if (redirect) {
              $location.url('/' + redirect);
            } else {
              $location.url('/bind');
            }
          }
        });
      }
    };
  }
]);

app.controller('Register', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', '$interval', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, $interval, appCookie) {
    var SEND_INTEVAL = 60;
    $scope.params = {};
    $scope.isTeacher = $location.path() === '/teacherregister';
    if ($scope.isTeacher) {
      $scope.vars = { title: '教师用户注册', registerMethod: 'registerTeacher', redirect: '/tests', verify: 'mt_tel' };
    } else {
      $scope.vars = { title: '学生用户注册', registerMethod: 'register', redirect: '/bind', verify: 'ms_tel' };
    }

    resApi.getSchoolList().$promise.then(function(ret) {
      $scope.schoolList = ret.data;
    });

    $scope.setCrumb([{
      title: $scope.vars.title
    }]);

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        var registerMethod = $scope.vars.registerMethod;
        resApi[registerMethod]($scope.params).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          if (ret.status === 1) {
            appCookie.create(ret.data);
            $scope.setUser(appCookie.getUser());
            $location.path($scope.vars.redirect);
          }
        });
      }
    };

    $scope.sentTime = SEND_INTEVAL;

    $scope.send = function() {
      var tel = $scope.params[$scope.vars.verify];
      if (isTelValid(tel)) {
        if ($scope.sent) {
          var info = $scope.sentTime + '秒后可重发';
          CommonFunc.showToastr({ info: info, status: 0 });
        } else {
          $scope.sent = true;
          startTimer();
          resApi.sendVerify({ tel: tel, type: 'register' }).$promise.then(function(ret) {
            CommonFunc.showToastr(ret);
          });
        }
      } else {
        CommonFunc.showToastr({ info: '手机号格式不正确', status: 0 });
      }
    };

    var timer;

    function startTimer() {
      timer = $interval(function() {
        $scope.sentTime--;
        if ($scope.sentTime === 0) {
          $interval.cancel(timer);
          $scope.sentTime = SEND_INTEVAL;
          $scope.sent = false;
        }
      }, 1000);
    }

    function isTelValid(text) {
      return /^[0-9]{11}$/g.test(text);
    }
  }
]);

app.controller('TeacherLogin', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    $scope.params = {};
    appCookie.destroy(true);
    resApi.logout({ isTeacher: 1 }).$promise.then(function(ret) { });

    $scope.setCrumb([{
      title: '教师用户登录'
    }]);

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        resApi.loginTeacher($scope.params).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          if (ret.status === 1) {
            appCookie.create(ret.data);
            $scope.setUser(appCookie.getUser());
            $location.path('/tests');
          }
        });
      }
    };
  }
]);

app.controller('TeacherTests', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc) {
    $scope.setCrumb([{
      title: '成绩单列表'
    }]);

    $scope.data = { list: [] };
    $scope.roleList = [];
    $scope.page = 1;

    $scope.loadData = function() {
      resApi.teacherTests({ page: $scope.page }).$promise.then(function(ret) {
        if (ret.status === 1) {
          if (ret.data.length > 0) {
            $scope.data.list = $scope.data.list.concat(ret.data);
          } else {
            CommonFunc.showToastr({
              info: '没有更多数据', status: 0
            });
          }
        } else {
          $scope.errorTitle = ret.info;
          $scope.errorMsg = ret.data;
        }
      });
    };

    $scope.loadMore = function() {
      $scope.page += 1;
      $scope.loadData();
    }

    $scope.loadData();

    resApi.teacherRoles().$promise.then(function(ret) {
      $scope.roleList = ret.data;
    });
  }
]);

app.controller('Bind', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc) {
    $scope.data = { list: [] };

    $scope.setCrumb([{
      title: '考生成绩单'
    }]);

    function loadData() {
      resApi.bindList().$promise.then(function(ret) {
        $scope.data = ret.data;
      });
    }

    loadData();

    $scope.remove = function(e, index) {
      e.stopPropagation();
      e.preventDefault();
      if (confirm("确定要解除绑定吗？")) {
        var hash = $scope.data.list[index].bind_hash;
        resApi.bindDetach({ hash: hash }).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          loadData();
        });
      }
      return false;
    };
  }
]);

app.controller('BindAdd', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc) {
    $scope.params = {};
    resApi.getTests().$promise.then(function(res) {
      if (res.status == 1) {
        $scope.testList = res.data;
      }
    });

    $scope.setCrumb([{
      title: '考生成绩单',
      path: '/bind'
    }, {
      title: '新增绑定'
    }]);

    resApi.getProfile().$promise.then(function(ret) {
      $scope.name = ret.data.ms_name;
    });

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        resApi.bindAdd($scope.params).$promise.then(function(ret) {
          if (ret.status === 1) {
            $location.path('/bind');
            CommonFunc.showToastr(ret);
          } else {
            $scope.bindError = ret.info;
            $scope.bindErrorMsg = ret.data || [];
            if (!$scope.bindErrorMsg.length) $scope.bindErrorMsg = [$scope.bindError];
            $("#modal-bind-error").modal("show");
          }
        });
      }
    };
  }
]);

app.controller('Profile', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    var user = $scope.getUser();
    if (!user) $location.path('/login');
    if (user.mt_id) {
      $scope.menus = [{
        text: '成绩单列表',
        action: 'tests'
      }];
      $scope.avatar = "teacher_female";
    } else {
      $scope.menus = [{
        text: '我的成绩单',
        action: 'bind'
      }, {
        text: '考场座位查询',
        action: 'querystudent'
      }, {
        text: '绑定操作记录',
        action: 'bindlog'
      }, {
        text: '修改姓名',
        action: 'changename'
      }, {
        text: '修改学校',
        action: 'changeschool'
      }];
      $scope.avatar = "user_male";
    }

    $scope.sex = 'male';
    $scope.menus.push({
      text: '修改密码',
      action: 'changepw'
    });

    $scope.setCrumb([{
      title: '个人中心'
    }]);

    function loadData() {
      var method = user.mt_id ? 'getTeacherProfile' : 'getProfile';
      resApi[method]().$promise.then(function(ret) {
        if (ret.status === 1) {
          $scope.data = ret.data;
        }
      });
    }

    loadData();
  }
]);

app.controller('ChangeName', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    $scope.params = { name: '' };

    $scope.setCrumb([{
      title: '修改姓名'
    }]);

    var fromPath = $location.search().from;
    $scope.backUrl = fromPath ? '#/bind/add' : '#/profile';

    resApi.getProfile().$promise.then(function(ret) {
      var data = ret.data;
      $scope.logCount = data.logCount;
      $scope.allowModify = data.ms_test === "1" || data.logCount === '0';
      $scope.params.name = data.ms_name;
    });

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        resApi.updateProfile($scope.params).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          if (ret.status === 1) {
            appCookie.create(ret.data);
            $scope.setUser(appCookie.getUser());
            $location.path('/profile');
          }
        });
      }
    };
  }
]);

app.controller('ChangeSchool', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    $scope.params = {};

    $scope.setCrumb([{
      title: '修改学校'
    }]);

    resApi.getSchoolList().$promise.then(function(ret) {
      $scope.schoolList = ret.data;
    });

    var fromPath = $location.search().from;
    $scope.backUrl = fromPath ? '#/bind/add' : '#/profile';

    resApi.getProfile().$promise.then(function(ret) {
      $scope.params.ms_id = ret.data.ms_id;
      $scope.params.ms_schoolid = ret.data.ms_schoolid;
    });

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        resApi.updateSchool($scope.params).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          if (ret.status === 1) {
            $location.path('/profile');
          }
        });
      }
    };
  }
]);

app.controller('ChangePW', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    $scope.params = {};

    $scope.setCrumb([{
      title: '修改密码'
    }]);

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        var user = $scope.getUser();
        $scope.params.type = user.mt_id ? 'teacher' : 'student';
        resApi.changePW($scope.params).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          if (ret.status === 1) {
            appCookie.create(ret.data);
            $scope.setUser(appCookie.getUser());
            $location.path('/profile');
          }
        });
      }
    };
  }
]);

app.controller('ForgotPW', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', '$interval', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, $interval, appCookie) {
    var SEND_INTEVAL = 60;
    $scope.params = {};
    var search = $location.search();
    if (search.teacher === '1') {
      $scope.title = '教师用户登录';
      $scope.redirect = '/teacherlogin';
      $scope.params.type = 'teacher';
    } else {
      $scope.title = '学生用户登录';
      $scope.redirect = '/login';
      $scope.params.type = 'student';
    }

    $scope.setCrumb([{
      title: $scope.title,
      path: $scope.redirect
    }, {
      title: '忘记密码'
    }]);

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        resApi.resetPW($scope.params).$promise.then(function(ret) {
          CommonFunc.showToastr(ret);
          if (ret.status === 1) {
            $location.path($scope.redirect);
          }
        });
      }
    };

    $scope.sentTime = SEND_INTEVAL;

    $scope.send = function() {
      var tel = $scope.params.tel;
      if (isTelValid(tel)) {
        if ($scope.sent) {
          var info = $scope.sentTime + '秒后可重发';
          CommonFunc.showToastr({ info: info, status: 0 });
        } else {
          $scope.sent = true;
          startTimer();
          resApi.sendVerify({ tel: tel, type: 'resetPW' }).$promise.then(function(ret) {
            CommonFunc.showToastr(ret);
          });
        }
      } else {
        CommonFunc.showToastr({ info: '手机号格式不正确', status: 0 });
      }
    };

    var timer;

    function startTimer() {
      timer = $interval(function() {
        $scope.sentTime--;
        if ($scope.sentTime === 0) {
          $interval.cancel(timer);
          $scope.sentTime = SEND_INTEVAL;
          $scope.sent = false;
        }
      }, 1000);
    }

    function isTelValid(text) {
      return /^[0-9]{11}$/g.test(text);
    }
  }
]);

app.controller('BindLog', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    $scope.setCrumb([{
      title: '个人中心',
      path: '/profile'
    }, {
      title: '绑定操作记录'
    }]);

    resApi.bindLogList().$promise.then(function(ret) {
      $scope.list = ret.data;
    });
  }
]);

app.controller('QueryStudent', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', 'appCookie',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, appCookie) {
    user = $scope.getUser();
    if (!user) $location.url('/login?redirect=querystudent');
    $scope.params = {};
    resApi.getTests().$promise.then(function(res) {
      if (res.status == 1) {
        $scope.testList = res.data;
      }
    });

    $scope.setCrumb([{
      title: '个人中心',
      path: '/profile'
    }, {
      title: '考场座位查询'
    }]);

    $scope.result = null;

    $scope.submit = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        resApi.queryStudent($scope.params).$promise.then(function(ret) {
          if (ret.status === 1) {
            $scope.result = ret.data;
          } else {
            CommonFunc.showToastr(ret);
          }
        });
      }
    };
  }
]);

// Base controller
app.controller('ApplicationController', ['$scope', '$location', 'resApi', '$timeout', '$route', 'appCookie', 'CommonFunc',
  function($scope, $location, resApi, $timeout, $route, appCookie, CommonFunc) {
    $scope.isViewLoading = true;
    $scope.isDataLoading = false;
    $scope.nav = "";
    $scope.user = null;
    $scope.breadcrumbs = [];
    $scope.isDesktop = device && device.desktop();

    $scope.groupMap = {
      'class': '班级',
      school: '学校',
      school_all: '学校',
      county: '县区',
      county_all: '县区',
      sex: '性别',
      province: '省份',
      city: '城市',
      kind: '类别',
      sgroup: '组别',
      term: '届别'
    };

    $scope.setCrumb = function(crumb) {
      $scope.breadcrumbs = crumb;
    };

    $scope.setNav = function(nav) {
      $scope.nav = nav;
    };

    $scope.getNavClass = function(path) {
      if (path == '/') {
        return $location.path() === '/' ? 'active' : '';
      } else {
        return ($location.path().substr(0, path.length) === path) ? 'active' : '';
      }
    };

    $scope.isHome = function() {
      return $location.path() === '/';
    };

    var fullScreenPaths = ['transcript'];
    var hideFooterPaths = [
      'survey',
      'scoreboard',
      'login',
      'register',
      'bind',
      'profile',
      'changename',
      'forgotpw',
      'buy',
      'complete',
      'changepw',
      'print',
      'bindlog',
      'tests',
      'teacherresult',
      'querystudent'
    ];

    $scope.isFullscreen = function() {
      var path = $location.path().split('/');
      return fullScreenPaths.indexOf(path[1]) >= 0;
    };

    $scope.showFooter = function() {
      var path = $location.path().split('/');
      return hideFooterPaths.indexOf(path[1]) === -1;
    };

    $scope.startLoading = function() {
      $scope.isDataLoading = true;
    };

    $scope.stopLoading = function() {
      $scope.isDataLoading = false;
    };

    $scope.$on('$viewContentLoaded', function() {
      $scope.isViewLoading = false;
    });

    $scope.setUser = function(user) {
      $scope.user = user;
    };

    $scope.getUser = function() {
      return $scope.user;
    };

    $scope.setUser(appCookie.getUser());

    $scope.logout = function(isTeacher) {
      var params = isTeacher ? { isTeacher: 1 } : {};
      resApi.logout(params).$promise.then(function(ret) {
        appCookie.destroy();

        $timeout(function() {
          $scope.setUser(null);
        }, 0);

        $location.path('/');
        CommonFunc.showToastr({ "status": 1, "info": "已登出" });
      });
    };
  }
]);

// Home controller
app.controller('Home', ['$scope', '$location', 'resApi', '$route',
  function($scope, $location, resApi, $route) {
    $scope.setNav('Home');
  }
]);

app.controller('OrderBuy', ['$scope', '$location', 'resApi', '$route', '$routeParams', 'CommonFunc', '$timeout',
  function($scope, $location, resApi, $route, $routeParams, CommonFunc, $timeout) {
    var user = $scope.getUser();
    if (!user) $location.path('/login');

    var existOrder = $location.search().order;
    if (existOrder) showPaying();
    $scope.showAlipay = true;

    $scope.params = { method: 'wechat' };
    var WechatUA = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
    $timeout(function() {
      if (device.mobile()) {
        if (WechatUA) {
          $scope.params.platform = 'wechat';
          var openId = $location.search().id;
          // 微信浏览器
          if (!openId) {
            CommonFunc.showToastr({ status: 0, info: '微信授权失败' });
            $location.path('/bind');
          } else {
            $scope.params.openId = openId;
          }
        } else {
          // 普通H5
          $scope.params.platform = 'h5';
        }
      } else {
        // 桌面端
        $scope.params.platform = 'desktop';
      }
    }, 0);

    function isUAAllowed() {
      if (WechatUA && WechatUA[1] < "5.0") {
        alert("微信版本过低请升级");
        return false;
      }
      return true;
    }

    $scope.setCrumb([{
      title: '购买会员'
    }]);

    resApi.getProduct().$promise.then(function(ret) {
      $scope.products = ret.data.products;
      $scope.specs = ret.data.specs;
      $scope.priceRange = ret.data.priceRange;
      $scope.params.productid = $scope.products[0].msg_id;
    });

    var timer = null;
    $scope.submit = function() {
      if ($scope.params.specid) {
        existOrder = null;
        var method = $scope.params.method;
        var platform = $scope.params.platform;
        if (timer) clearInterval(timer);
        if (method === 'alipay') {
          if (platform === 'wechat') {
            $('#modal-alipay-wx').modal('show');
            return;
          } else {
            var newWindow = window.open();
          }
        }
        resApi.buy($scope.params).$promise.then(function(ret) {
          if (ret.status == 1) {
            $scope.order = ret.data;
            if (method === 'wechat') {
              if (platform === 'wechat') {
                if (!isUAAllowed()) return;
                doPay();
                $scope.startLoading();
              } else if (platform === 'h5') {
                showPaying();
                location.href = $scope.order.url;
              } else if (platform === 'desktop') {
                showQRCode();
                timer = setInterval(function() {
                  checkOrder();
                }, 1000);
              }
            } else if (method === 'alipay' && platform !== 'wechat') {
              showPaying();
              newWindow.location = $scope.order.url;
            }
          } else {
            $scope.stopLoading();
            CommonFunc.showToastr(ret);
          }
        });
      } else {
        CommonFunc.showToastr({ status: 0, info: '请选择时长' });
      }
    };

    function showQRCode() {
      $scope.payName = $scope.params.method === 'wechat' ? '微信' : '支付宝';
      $scope.payQRCode = $scope.order.src;
      $('#modal-qrcode').modal('show');
    }

    function showPaying() {
      $timeout(function() {
        $('#modal-paying').modal('setting', 'closable', false).modal('show');
      }, 0);
    }

    $scope.payCheck = function(event) {
      event.preventDefault();
      $('#modal-paying').modal({
        onHide: function() {
          checkOrder(existOrder);
        }
      }).modal('hide');
      return false;
    };

    function checkOrder(existOrderId) {
      var id = existOrderId || ($scope.order && $scope.order.id);
      if (!id) return;
      resApi.checkOrder({ id: id }).$promise.then(function(ret) {
        if (ret.status == 1) {
          if (timer) clearInterval(timer);
          $('#modal-qrcode').modal('hide');
          $location.url('/complete');
        } else {
          if (!timer) {
            CommonFunc.showToastr(ret);
          }
        }
      });
    }

    function cancelOrder(existOrderId) {
      var id = existOrderId || $scope.order.id;
      resApi.cancelOrder({ id: id }).$promise.then(function(ret) {
        CommonFunc.showToastr({ status: 0, info: '支付已取消' });
      });
    }

    function onBridgeReady() {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', $scope.order.data,
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            checkOrder();
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            cancelOrder();
          } else {
            CommonFunc.showToastr({ status: 0, info: '支付发生错误：' + res.err_desc + res.err_msg });
          }
          WeixinJSBridge.log(res.err_msg);
          $scope.stopLoading();
          $scope.$apply();
        }
      );
    }

    function doPay() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    }
  }
]);

// Common
app.factory('resApi', function($resource, BASE_URL) {
  return $resource('resApi', {}, {
    getTests: {
      method: 'GET',
      url: BASE_URL + 'testList'
    },
    getScoreOverview: {
      method: 'GET',
      url: BASE_URL + 'scoreOverview/hash/:hash'
    },
    getScoreDetail: {
      method: 'GET',
      url: BASE_URL + 'scoreDetailView/hash/:hash'
    },
    getAddtionalFilterList: {
      method: 'POST',
      url: BASE_URL + 'getAddtionalFilterList'
    },
    getTeacherResult: {
      method: 'POST',
      url: BASE_URL + 'teacherResult'
    },
    getScoreByClass: {
      method: 'POST',
      url: BASE_URL + 'scoreByClass'
    },
    getCourseResultByClass: {
      method: 'POST',
      url: BASE_URL + 'courseResultByClass'
    },
    sendVerify: {
      method: 'POST',
      url: BASE_URL + 'sendVerify'
    },
    register: {
      method: 'POST',
      url: BASE_URL + 'register'
    },
    login: {
      method: 'POST',
      url: BASE_URL + 'login'
    },
    registerTeacher: {
      method: 'POST',
      url: BASE_URL + 'registerTeacher'
    },
    loginTeacher: {
      method: 'POST',
      url: BASE_URL + 'loginTeacher'
    },
    logout: {
      method: 'POST',
      url: BASE_URL + 'logout'
    },
    bindList: {
      method: 'GET',
      url: BASE_URL + 'bindList'
    },
    bindAdd: {
      method: 'POST',
      url: BASE_URL + 'bindAdd'
    },
    updateProfile: {
      method: 'POST',
      url: BASE_URL + 'updateProfile'
    },
    updateSchool: {
      method: 'POST',
      url: BASE_URL + 'updateSchool'
    },
    resetPW: {
      method: 'POST',
      url: BASE_URL + 'resetPW'
    },
    bindDetach: {
      method: 'POST',
      url: BASE_URL + 'bindDetach'
    },
    getProduct: {
      method: 'POST',
      url: BASE_URL + 'getProduct'
    },
    buy: {
      method: 'POST',
      url: BASE_URL + 'buy'
    },
    checkOrder: {
      method: 'POST',
      url: BASE_URL + 'checkOrder'
    },
    cancelOrder: {
      method: 'POST',
      url: BASE_URL + 'cancelOrder'
    },
    getProfile: {
      method: 'GET',
      url: BASE_URL + 'getProfile'
    },
    changePW: {
      method: 'POST',
      url: BASE_URL + 'changePW'
    },
    bindLogList: {
      method: 'POST',
      url: BASE_URL + 'bindLogList'
    },
    subscoreResult: {
      method: 'POST',
      url: BASE_URL + 'subscoreResult'
    },
    getTeacherProfile: {
      method: 'POST',
      url: BASE_URL + 'getTeacherProfile'
    },
    teacherTests: {
      method: 'POST',
      url: BASE_URL + 'teacherTests'
    },
    teacherRoles: {
      method: 'POST',
      url: BASE_URL + 'teacherRoles'
    },
    resultMeta: {
      method: 'POST',
      url: BASE_URL + 'resultMeta'
    },
    detailResult: {
      method: 'POST',
      url: BASE_URL + 'detailResult'
    },
    queryStudent: {
      method: 'POST',
      url: BASE_URL + 'queryStudent'
    },
    getUpgradeByCourse: {
      method: 'POST',
      url: BASE_URL + 'getUpgradeByCourse'
    },
    addQuality: {
      method: 'POST',
      url: BASE_URL + 'addQuality'
    },
    updateQuality: {
      method: 'POST',
      url: BASE_URL + 'updateQuality'
    },
    deleteQuality: {
      method: 'POST',
      url: BASE_URL + 'deleteQuality'
    },
    getQualityMenu: {
      method: 'POST',
      url: BASE_URL + 'getQualityMenu'
    },
    getStudentByClass: {
      method: 'POST',
      url: BASE_URL + 'getStudentByClass'
    },
    getSchoolList: {
      method: 'GET',
      url: BASE_URL + 'getSchoolList'
    },
    getErrorCompare: {
      method: 'POST',
      url: BASE_URL + 'getErrorCompare'
    },
  });
});

app.factory('resSurvey', function($resource, BASE_URL) {
  return $resource('resSurvey', {}, {
    getSurvey: {
      method: 'POST',
      url: BASE_URL + 'getSurvey'
    },
    doSurvey: {
      method: 'POST',
      url: BASE_URL + 'doSurvey'
    }
  });
});

/*
  A simple, lightweight jQuery plugin for creating sortable tables.
  https://github.com/kylefox/jquery-tablesort
  Version 0.0.11
*/

(function($) {
  $.tablesort = function($table, settings) {
    var self = this;
    this.$table = $table;
    this.$thead = this.$table.find('thead');
    this.settings = $.extend({}, $.tablesort.defaults, settings);
    this.$sortCells = this.$thead.length > 0 ? this.$thead.find('th:not(.no-sort)') : this.$table.find('th:not(.no-sort)');
    this.$sortCells.on('click.tablesort', function() {
      self.sort($(this));
    });
    this.index = null;
    this.$th = null;
    this.direction = null;
  };

  $.tablesort.prototype = {

    sort: function(th, direction) {
      var start = new Date(),
        self = this,
        table = this.$table,
        rowsContainer = table.find('tbody').length > 0 ? table.find('tbody') : table,
        rows = rowsContainer.find('tr').has('td, th'),
        cells = rows.find(':nth-child(' + (th.index() + 1) + ')').filter('td, th'),
        sortBy = th.data().sortBy,
        sortedMap = [];

      var unsortedValues = cells.map(function(idx, cell) {
        if (sortBy)
          return (typeof sortBy === 'function') ? sortBy($(th), $(cell), self) : sortBy;
        return ($(this).data().sortValue != null ? $(this).data().sortValue : $(this).text());
      });
      if (unsortedValues.length === 0) return;

      //click on a different column
      if (this.index !== th.index()) {
        this.direction = 'asc';
        this.index = th.index();
      } else if (direction !== 'asc' && direction !== 'desc')
        this.direction = this.direction === 'asc' ? 'desc' : 'asc';
      else
        this.direction = direction;

      direction = this.direction == 'asc' ? 1 : -1;

      self.$table.trigger('tablesort:start', [self]);
      self.log("Sorting by " + this.index + ' ' + this.direction);

      // Try to force a browser redraw
      self.$table.css("display");
      // Run sorting asynchronously on a timeout to force browser redraw after
      // `tablesort:start` callback. Also avoids locking up the browser too much.
      setTimeout(function() {
        self.$sortCells.removeClass(self.settings.asc + ' ' + self.settings.desc);
        for (var i = 0, length = unsortedValues.length; i < length; i++) {
          sortedMap.push({
            index: i,
            cell: cells[i],
            row: rows[i],
            value: unsortedValues[i]
          });
        }

        sortedMap.sort(function(a, b) {
          return self.settings.compare(a.value, b.value) * direction;
        });

        $.each(sortedMap, function(i, entry) {
          rowsContainer.append(entry.row);
        });

        th.addClass(self.settings[self.direction]);

        self.log('Sort finished in ' + ((new Date()).getTime() - start.getTime()) + 'ms');
        self.$table.trigger('tablesort:complete', [self]);
        //Try to force a browser redraw
        self.$table.css("display");
      }, unsortedValues.length > 2000 ? 200 : 10);
    },

    log: function(msg) {
      if (($.tablesort.DEBUG || this.settings.debug) && console && console.log) {
        console.log('[tablesort] ' + msg);
      }
    },

    destroy: function() {
      this.$sortCells.off('click.tablesort');
      this.$table.data('tablesort', null);
      return null;
    }

  };

  $.tablesort.DEBUG = false;

  $.tablesort.defaults = {
    debug: $.tablesort.DEBUG,
    asc: 'sorted ascending',
    desc: 'sorted descending',
    compare: function(a, b) {
      if (!isNaN(a) && !isNaN(b)) return a - b;
      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      } else {
        return 0;
      }
    }
  };

  $.fn.tablesort = function(settings) {
    var table, sortable, previous;
    return this.each(function() {
      table = $(this);
      previous = table.data('tablesort');
      if (previous) {
        previous.destroy();
      }
      table.data('tablesort', new $.tablesort(table, settings));
    });
  };

})(window.Zepto || window.jQuery);

app.controller('Survey', ['$scope', '$location','resSurvey', '$route', '$routeParams', '$sce',
  function($scope, $location, resSurvey, $route, $routeParams, $sce){
  $scope.step = 1;
  $scope.total = 0;
  $scope.finished = -1;
  var index = 0;
  var list = [];
  var questionAnswer = "";
  var key = "";
  $scope.answermulti = ['','','',''];

  resSurvey.getSurvey({
    testid: $routeParams.testId, student: $routeParams.student
  }).$promise.then(function(res){
    $scope.studentData = res.data.student;
    $scope.surveyData = res.data.survey;
    list = res.data.list;
    $scope.total = list.length;
    $scope.finished = res.data.finished;
    for(var i = 0, l = list.length; i < l; i++){
      list[i].question.sc_options = list[i].question.sc_options.split('<br/>');
      list[i].solution.sc_options = list[i].solution.sc_options.split('<br/>');
      list[i].problem.sc_options = list[i].problem.sc_options.split('<br/>');
      convertToHtml(list[i].question.sc_options);
      convertToHtml(list[i].solution.sc_options);
      convertToHtml(list[i].problem.sc_options);
    }
    index = $scope.finished == $scope.total ? $scope.finished - 1 : $scope.finished;
    setCurrentItem(index, 'question');
    setProgress();
  });

  function convertToHtml(list){
    for (var i = list.length - 1; i >= 0; i--) {
      list[i] = $sce.trustAsHtml(list[i]);
    }
  }

  function setProgress(){
    var progress = Math.ceil($scope.finished / $scope.total * 100);
    if(progress > 75){
      $scope.barClass = 'green';
    }else if(progress > 50){
      $scope.barClass = 'olive';
    }else if(progress > 25){
      $scope.barClass = 'yellow';
    }else{
      $scope.barClass = 'red';
    }
    $scope.barWidth = progress + '%';
  };

  function setCurrentItem(index, key){
    if(index < list.length){
      $scope.currentItem = list[index][key];
    }else{
      $scope.currentItem = null;
    }
  }

  $scope.back = function(){
    $location.path('/scoreboard/test/'+$routeParams.testId+'/student/'+$routeParams.student);
  };

  $scope.showSubmit = function(){
    if($scope.currentItem && $scope.currentItem.sc_type == 2){
      return $scope.answermulti.join('');
    }else{
      return $scope.answer;
    }
  };

  $scope.submit = function(){
    if($scope.currentItem.sc_type == 2){
      $scope.answer = $scope.answermulti.join('');
      $scope.answermulti = ['','','',''];
    }
    if(!$scope.answer)return;
    if($scope.step == 1){
      key = $scope.answer == $scope.currentItem.sc_answer ? 'solution' : 'problem';
      setCurrentItem(index, key);
      questionAnswer = $scope.answer;
      $scope.step = 2;
    }else{
      var request = {
        ss_surveyid: $scope.surveyData.survey_id,
        ss_groupid: $scope.currentItem.sc_groupid,
        ss_testnumber: $routeParams.student,
        ss_answer1: questionAnswer,
        ss_correct: key == 'solution' ? 1 : 0,
        ss_answer2: $scope.answer
      };
      resSurvey.doSurvey(request).$promise.then(function(res){
        if(res.status == 1){
          setCurrentItem(++index, 'question');
          $scope.step = 1;
          $scope.finished = res.data;
          setProgress();
        }else{
          alert('提交回答时发生错误，请重试');
        }
      });
    }
    $scope.answer = undefined;
  };
}]);

// Transcript index controller
app.controller('Transcript', ['$scope', '$location', 'resApi', '$route', '$routeParams',
  function($scope, $location, resApi, $route, $routeParams) {
    $scope.testIndex = 0;
    $scope.submitted = false;
    $scope.isTeacher = !!$routeParams.teacher;
    if ($scope.isTeacher) {
      $scope.text = {
        currentRole: '教师',
        otherRole: '学生',
        placeholder: '查询密码',
        tip: '查询密码请咨询学校教务人员'
      };
    } else {
      $location.path('/bind');
    }

    resApi.getTests().$promise.then(function(res) {
      if (res.status == 1) {
        $scope.testList = res.data;
      }
    });

    $scope.showTestOptions = function() {
      $('#modal-tests').modal('show');
    };

    $scope.changeRole = function() {
      var url = $scope.isTeacher ? '/transcript' : '/transcript?teacher=1';
      $location.url(url);
    };

    $scope.changeTest = function(index) {
      $scope.testIndex = index;
      $('#modal-tests').modal('hide');
    };

    $scope.search = function() {
      $scope.submitted = true;
      if ($scope.ngForm.$valid) {
        var testId = $scope.testList[$scope.testIndex].id;
        var type = $scope.isTeacher ? 'teacher' : 'student';
        $location.url("/scoreboard/test/" + testId + "/" + type + "/" + $scope.searchkey);
      }
    };
  }
]);

function formatLevelRangeTable(levelRangeTable) {
  levelRangeTable = levelRangeTable || [];
  var result = [];
  var len = Math.ceil(levelRangeTable.length / 2);
  for (var i = 0; i < len; i++) {
    result.push({
      score: levelRangeTable[i].score,
      rank: levelRangeTable[i].rank,
      score2: (levelRangeTable[i + len] || {}).score || '',
      rank2: (levelRangeTable[i + len] || {}).rank || '',
    });
  }
  return result;
}

// Scoreboard controller
app.controller('Scoreboard', ['$scope', '$location', 'resApi', '$route', '$timeout', '$routeParams', '$sce',
  function($scope, $location, resApi, $route, $timeout, $routeParams, $sce) {
    $scope.setCrumb([{
      title: '学生查分'
    }]);

    $scope.onlyError = true;
    $scope.courseIndex = 0;
    $scope.upgradeIndex = 0;
    $scope.data = { 'isAdvance': true, 'student': {}, 'overview': [], showScore: true, open: true };
    $scope.dataDetail = { 'questions': [], 'advice': {} };
    $scope.startLoading();
    $scope.selectedQuestion = {};
    $scope.courseHasNote = false;
    $scope.hash = $routeParams.hash;
    $scope.curError = {};
    $scope.curErrorIndex = -1;
    $scope.errorQuestions = [];
    var errorUrlMap = {};

    $timeout(function() {
      resApi.getScoreOverview({ hash: $routeParams.hash }).$promise.then(function(res) {
        $scope.userInputs = { testtitle: res.data.testtitle, student: res.data.student.testnumber };
        if (res.status == 1) {
          res.data.levelRangeTable = formatLevelRangeTable(res.data.levelRangeTable);
          $scope.data = res.data;
          if (res.data.student && res.data.open && res.data.schoolEnabled) {
            $scope.surveyUrl = '/survey/test/' + res.data.testId + '/student/' + res.data.student.testnumber;
            if ($location.path().indexOf('print') < 0) initChart(res.data.score);
          }

          if (res.data.showScore && res.data.student && res.data.open && res.data.schoolEnabled) {
            $scope.upgradeIndex = res.data.score.length - 1;
            loadScoreDetail({ hash: $routeParams.hash });
          }
        }
        $scope.stopLoading();
      });
    }, 500);

    $scope.print = function() {
      window.print();
    };

    $scope.goSurvey = function() {
      $location.path($scope.surveyUrl);
    };

    $scope.changeError = function(step) {
      loadErrorQuestion(step);
    };

    $scope.showQA = function() {
      $('#modal-qa').modal('show');
    };

    function initErrorList() {
      var curCid = $scope.data.score[$scope.courseIndex].cid;
      $scope.errorQuestions = ($scope.dataDetail.questions || []).filter(function(item) {
        return item.cid === curCid && item.score !== item.fullscore;
      });
    }

    function loadErrorQuestion(step) {
      if (!step) step = 0;
      var questions = $scope.errorQuestions;
      var newIndex = step ? $scope.curErrorIndex + step : step;
      if (questions[newIndex]) {
        $scope.curErrorIndex = newIndex;
        $scope.curError = questions[$scope.curErrorIndex];
        loadErrorUrl();
      }
    }

    function loadErrorUrl() {
      var area = $scope.curError.answer_area;
      if (!area) {
        $scope.curError.url = '';
        $scope.curError.maxUrl = '';
        return;
      }
      var qid = $scope.curError.qid;
      if (errorUrlMap[qid]) {
        $scope.curError.url = errorUrlMap[qid].url;
        $scope.curError.maxUrl = errorUrlMap[qid].maxUrl;
      } else {
        debugger;
        var params = {
          testid: $scope.data.testId,
          testnumber: $scope.data.student.testnumber,
          pid: $scope.curError.pid,
          qid: qid,
          area: area,
          max: $scope.curError.max,
          best_answer_testnumber: $scope.curError.best_answer_testnumber,
        };
        resApi.getErrorCompare(params).$promise.then(function(ret) {
          errorUrlMap[qid] = ret.data;
          $scope.curError.url = ret.data.url;
          $scope.curError.maxUrl = ret.data.maxUrl;
        });
      }
    }

    $scope.changeCourse = function(index) {
      $scope.courseIndex = index;
      initErrorList();
      loadErrorQuestion();
      $('#modal-course').modal('hide');
    };

    $scope.showModalPaper = function() {
      var cIndex = $scope.courseIndex;
      $scope.paperSrc = $scope.data.score[cIndex].picUrl;
      $('#modal-paper').modal('show');
    };

    $scope.showModalCourse = function() {
      $('#modal-course').modal('show');
    };

    $scope.changeUpgrade = function(index) {
      $scope.upgradeIndex = index;
      $scope.getUpgradeByCourse();
      $('#modal-courseall').modal('hide');
    };

    $scope.showModalCourseAll = function() {
      $('#modal-courseall').modal('show');
    };

    $scope.showAnswer = function(index) {
      $scope.selectedQuestion = $scope.dataDetail.questions[index];
      $timeout(function() {
        $('#modal-answer').modal('show');
      }, 0);
    };

    $scope.showModalAnswer = function(index) {
      if (index !== undefined) $scope.courseIndex = index;
      $('#modal-answerAll').modal('show');
    };

    $scope.getUpgradeByCourse = function() {
      var index = $scope.upgradeIndex;
      var courseData = $scope.data.score[index];
      var param = {
        testId: $scope.data.testId,
        cid: courseData.id,
        score: courseData.score,
        sRank: courseData.sRank,
        cRank: courseData.cRank,
        testnumber: $scope.data.student.testnumber,
        class: $scope.data.student.class,
        school: $scope.data.student.school
      }
      resApi.getUpgradeByCourse(param).$promise.then(function(ret) {
        $scope.upgradeList = ret.data;
      });
    }

    function initChart(list) {
      if (!window.echarts) {
        $timeout(function() {
          initChart(list);
        }, 1000);
        return;
      }
      list = list || [];
      var element = document.getElementById('graph');
      if (!element) return;
      var myChart = echarts.init(element);
      var indicators = [];
      var dataList = [];
      for (var i = 0, len = list.length; i < len; i++) {
        indicators.push({
          name: list[i].name,
          max: list[i].fullscore
        });
        dataList.push(list[i].score);
      }

      var option = {
        textStyle: {
          fontSize: 14
        },
        radar: {
          indicator: indicators
        },
        series: [{
          name: 'score',
          type: 'radar',
          itemStyle: { normal: { color: '#2185D0' } },
          data: [{
            value: dataList,
            name: 'scores',
            label: {
              normal: {
                show: true,
                formatter: function(params) {
                  return params.value;
                }
              }
            }
          }]
        }]
      };

      myChart.setOption(option);
    }

    function loadScoreDetail(params) {
      var scores = $scope.data.score;
      for (var i = scores.length - 1; i >= 0; i--) {
        scores[i].hasNote = false;
      }
      if ($location.path().indexOf('print') >= 0) params.print = 1;
      resApi.getScoreDetail(params).$promise.then(function(res) {
        if (res.status == 1) {
          $scope.dataDetail = res.data;
          if (!res.data.print) {
            var questions = $scope.dataDetail.questions;
            for (var i = questions.length - 1; i >= 0; i--) {
              questions[i].hasNote = !!questions[i].note;
              if (questions[i].hasNote) {
                setHasNote(questions[i].cid);
              }
              var note = questions[i].note || '暂无';
              questions[i].note = $sce.trustAsHtml(note);
            }
            initErrorList();
            loadErrorQuestion();
          }
        }
      });
    }

    function setHasNote(cid) {
      var scores = $scope.data.score;
      for (var i = scores.length - 1; i >= 0; i--) {
        if (cid === scores[i].id) scores[i].hasNote = true;
      }
    }

    $scope.back = function() {
      $location.path("/bind");
    };
  }
]);

app.constant('CHART_DEF', {
  average: {
    title: '均分比统计',
    subTitle: '均分比等于当前分组的平均分与总体平均分的比值',
    key: 'percent_{id}'
  },
  good: {
    title: '优秀人数统计',
    subTitle: '总分大于等于优秀分数线的人数',
    key: 'count_{id}'
  },
  pass: {
    title: '合格人数统计',
    subTitle: '总分大于等于合格分数线的人数',
    key: 'count_{id}'
  },
  levelscore: {
    title: '达线人数比例',
    subTitle: '总分大于等于不同等级分数线的人数，共A-E五个等级',
    key: 'percent_{id}',
    formatPercent: true
  },
  distribution: {
    title: '成绩分段分布',
    subTitle: '科目满分平均分为10段，统计每段的人数和满分人数',
    key: 'per_{id}',
    formatPercent: true,
    legend: '分段人数比例'
  },
  question: {
    title: '小题难度系数',
    subTitle: '小题难度系数等于小题平均分除以小题满分',
    key: 'diff',
    legend: '难度系数'
  },
  option: {
    title: '客观题选项分布',
    subTitle: '选项分布统计各个选项的填涂次数，以及未填的次数',
    key: '{id}',
    legend: '客观题选项分布',
    pie: true
  },
  answerrate: {
    title: '考生答题分析',
    subTitle: '统计各小题的均分比、绝对难度、相对难度',
    key: '{id}',
    legend: ['均分比', '绝对难度', '相对难度'],
    radar: true
  },
});

app.controller('TeacherResult', ['$scope', '$location', 'resApi', '$route', '$timeout', '$routeParams', 'BASE_URL', '$sce', 'CommonFunc', 'CHART_DEF',
  function($scope, $location, resApi, $route, $timeout, $routeParams, BASE_URL, $sce, CommonFunc, CHART_DEF) {
    $scope.meta = { open: true };
    $scope.data = { test: {} };
    $scope.role = {};
    $scope.type = '';
    $scope.levels = ['A', 'B', 'C', 'D', 'E'];
    $scope.divs = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10'];
    $scope.letters = [];
    $scope.order = '';
    $scope.orderReverse = true;
    $scope.filterKey = 'school';
    $scope.filterValue = '';
    $scope.testId = $routeParams.id;
    $scope.rank = 20;
    $scope.filters = { score: true, crank: true, srank: true, svar: true, type: true, min: true, stddev: true, answer: true, avg: true, efg: true };
    $scope.groupTypes = ['quality', 'pass', 'good', 'average', 'levelscore', 'distribution'];
    $scope.tabCid = null;
    $scope.page = 1;
    $scope.limit = 10;
    $scope.total = 0;
    $scope.unitList = [];
    $scope.questions = [];
    $scope.printParams = {
      type: 'student',
      range: 'all',
      range_data: 'all',
      diagnoseType: 'error',
    };
    $scope.qualityParams = {
      testid: $scope.testId
    };
    $scope.qualityHeaders = [];
    $scope.qualityScoreType = 'type';
    $scope.qualityDateHeaders = [];
    $scope.qulityDateList = [];

    var chart;

    function getXAxis() {
      var type = $scope.type;
      if (type === 'levelscore') {
        var levelScores = $scope.levelScores;
        return $scope.levels.map(function(item, index) {
          return item + '等（' + levelScores[index] + ' +）';
        });
      } else if (type === 'distribution') {
        var fullscore = $scope.courses.filter(function(item) {
          return item.id === $scope.graphCid;
        })[0].score;
        var span = Math.floor(fullscore / 10);
        return $scope.divs.map(function(item, index) {
          var bottom = span * index;
          var top = span * (index + 1);
          var leftBracket = index === 0 ? '(' : '[';
          return leftBracket + bottom + ',' + top + ')';
        }).concat(['满分']);
      } else if (type === 'question') {
        return dataList.map(function(item) { return item.qname; });
      } else {
        return $scope.courses.map(function(item) {
          if (type === 'good') {
            return item.name + '（' + item.good_score + ' +）';
          } else if (type === 'pass') {
            return item.name + '（' + item.pass_score + ' +）';
          } else {
            return item.name;
          }
        });
      }
    }

    function getLabels() {
      var type = $scope.type;
      if (type === 'levelscore') {
        return ['0', '1', '2', '3', '4'];
      } else if (type === 'distribution') {
        return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'full'];
      } else if (type === 'option') {
        return $scope.letters;
      } else {
        return $scope.courses.map(function(item) { return item.id });
      }
    }

    function getSerieData(unit) {
      var type = $scope.type;
      var ret;
      var data = [];
      var labelKeys = getLabels();
      var def = CHART_DEF[type];
      if(type === 'answerrate') {
        data = [{value: [], name: '均分比'}, {value: [], name: '绝对难度'}, {value: [], name: '相对难度'}];
      }

      dataList.filter(function(item) {
        var unitMatch = !unit || unit === getRowUnit(item);
        var categoryMatch = true;
        if (type === 'distribution') {
          categoryMatch = item.cid == $scope.graphCid;
        } else if (type === 'option') {
          categoryMatch = item.qid == $scope.graphQid;
        }
        return unitMatch && categoryMatch;
      }).forEach(function(item) {
        if (type === 'question') {
          data.push(item[def.key]);
        } else if (type === 'answerrate') {
          data[0].value.push(item.avgratio);
          data[1].value.push(item.diff);
          data[2].value.push(item.relativediff);
        } else {
          for (var i = 0; i < labelKeys.length; i++) {
            var key = def.key.replace('{id}', labelKeys[i]);
            if (type === 'option') {
              data.push({
                value: item[key],
                name: labelKeys[i] === '_' ? '未填' : labelKeys[i]
              });
            } else {
              data.push(item[key]);
            }
          }
        }
      });

      var unitName = unit || def.legend;
      if(type === 'answerrate') unitName = def.title;
      ret = {
        data: data,
        name: unitName,
        type: def.radar ? 'radar' : (def.pie ? 'pie' : 'line')
      }
      if (def.pie) {
        ret.center = ['50%', '50%'];
        ret.radius = '60%';
      }
      return ret;
    }

    $scope.changeCurrentUnit = function() {
      loadChart();
    };

    $scope.changeCompareUnit = function() {
      loadChart();
    };

    $scope.showPrintScore = function() {
      $('#modal-print-score').modal('show');
    }

    function loadChart() {
      if (!window.echarts) {
        $timeout(function() {
          loadChart();
        }, 1000);
        return;
      }
      var type = $scope.type;
      var def = CHART_DEF[type];
      if (!def) return;
      $scope.chartName = def.title;
      if (type === 'option' && !$scope.questions.length) return;
      if (!chart) chart = echarts.init(document.getElementById('chart'));

      var xAxisList = getXAxis();
      var legend = [];
      var series = [];
      if ($scope.currentUnit) {
        series.push(getSerieData($scope.currentUnit));
        legend.push($scope.currentUnit);
      }
      if ($scope.compareUnit) {
        series.push(getSerieData($scope.compareUnit));
        legend.push($scope.compareUnit);
      }
      if ($scope.groupby === 'all' || type === 'question') {
        series.push(getSerieData());
        legend.push(def.legend);
      }
      if (type === 'option') {
        series.push(getSerieData());
        $scope.letters.forEach(function(letter) {
          legend.push(letter === '_' ? '未填' : letter);
        });
      }
      if (type === 'answerrate') {
        series.push(getSerieData());
        legend = def.legend;
      }

      var option = {
        title: {
          text: def.title,
          subtext: def.subTitle,
          x: 'center',
          top: 5
        },
        legend: { data: legend },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        series: series
      };

      if (def.pie) {
        option.legend.left = 'left';
        option.legend.orient = 'vertical';
        option.tooltip = {
          trigger: 'item',
          formatter: "选{b}的人数 <br/>{c} ({d}%)"
        };
      } else if (def.radar) {
        option.legend.left = 'left';
        option.legend.orient = 'vertical';
        option.radar = {
          center: ['50%', '55%'],
          radius: '60%',
          // shape: 'circle',
          // name: {
          //     textStyle: {
          //         color: '#fff',
          //         backgroundColor: '#999',
          //         borderRadius: 3,
          //         padding: [3, 5]
          //     }
          // },
          indicator: dataList.map(function(row) {
            return {text: row.name, name: row.name, max: 1.5};
          })
        };
      } else {
        option.legend.top = 55;
        option.grid = {
          top: 85,
          bottom: 14,
          left: 14,
          right: 14,
          containLabel: true
        };
        option.toolbox.feature.magicType = { type: ['line', 'bar'] };
        option.toolbox.feature.restore = {};
        option.xAxis = {
          type: 'category',
          axisLabel: { interval: 0 },
          data: xAxisList
        };
        option.yAxis = {
          type: 'value'
        };
        option.tooltip = { trigger: 'axis' };
        if (def.formatPercent) {
          option.yAxis.axisLabel = {
            formatter: '{value}%'
          };
          option.tooltip.formatter = function(params) {
            var title = params[0].name + '<br/>';
            return title + params.map(function(item) {
              var dot = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + item.color + '"></span>';
              return dot + '<span>' + item.seriesName + '：' + item.value + '%</span>';
            }).join('<br/>');
          }
        }
      }

      chart.clear();
      chart.setOption(option, true);
    }

    $scope.onRangeChange = function() {
      var range = $scope.printParams.range;
      if(range === 'all') {
        $scope.printParams.range_data = 'all';
        $scope.curFilterList = [];
        $timeout(function() {
          $("#range_data").dropdown("set selected", 'all');
        }, 0);
      } else {
        resApi.getAddtionalFilterList({testid: $scope.testId, field: range}).$promise.then(function(ret) {
          $scope.curFilterList = ret.data;
          $scope.printParams.range_data = ret.data.length ? ret.data[0] : 'all';
          $timeout(function() {
            $("#range_data").dropdown("set selected", $scope.printParams.range_data);
          }, 0);
        });
      }
    };

    resApi.resultMeta({ testId: $scope.testId }).$promise.then(function(ret) {
      $scope.meta = ret.data;
      $scope.roleList = $scope.meta.roles;
      $scope.menus = $scope.meta.menus;
      $scope.isMultiSchool = $scope.meta.schools.length > 1;
      // $scope.isMultiSchool = true;
      $scope.filterTypeList = $scope.meta.filters;
      $scope.printParams.unitname = ret.data.unitType === '0' ? ret.data.school_fullname : '目标教育';
      if(ret.data.classes.length) $scope.printParams.classname = ret.data.classes[0].key;
      if(ret.data.courses.length) $scope.printParams.cid = ret.data.courses[0].id;

      $scope.printParams.classname = 'all';

      fetchQualityMenu();

      var counties = $scope.meta.counties;
      if (counties) {
        $scope.county = counties[0].key;
        $scope.changeCounty();
      } else {
        $scope.schoolList = $scope.meta.schools;
        $scope.school = $scope.schoolList[0].key;
      }

      if ($scope.isMultiSchool) {
        $scope.groupby = 'school';
      } else {
        $scope.groupby = 'class';
      }

      $scope.school_fullname = $scope.meta.school_fullname;

      $scope.setCrumb([
        { title: '成绩单列表', path: '/tests' },
        { title: $scope.meta.test.testtitle }
      ]);

      if ($scope.roleList.length > 0) {
        $scope.role = $scope.roleList[0];
        if ($scope.meta.open) setMenuList();
      }

      $timeout(function() {
        $(".ui.dropdown").dropdown({
          fullTextSearch: true,
        });
      }, 0);
    });

    $scope.changeCounty = function() {
      $scope.schoolList = $scope.meta.schools.filter(function(item) {
        return item.district_id === $scope.county;
      });
      $scope.school = $scope.schoolList[0].key;
      $scope.changeSchool();
      $timeout(function() { $("#school").dropdown("set selected", $scope.school); }, 0);
    };

    $scope.changeSchool = function() {
      _resetFilter();
      $scope.loadData();
    };

    $scope.onChangeType = function(val) {
      $scope.printParams.type = val;
    };

    $scope.changeTabCourse = function(event, cid) {
      event.preventDefault();
      if ($scope.type === 'topN' || $scope.type === 'note') {
        $scope.loadData(cid);
      }
    };

    $scope.changeGoodCid = function() {
      $scope.goodScore = $scope.courses.filter(function(item) {
        return item.id === $scope.goodCid;
      })[0].good_score - 0;
    };

    $scope.changePassCid = function() {
      $scope.passScore = $scope.courses.filter(function(item) {
        return item.id === $scope.passCid;
      })[0].pass_score - 0;
    };

    $scope.changeGoodScore = function() {
      $scope.courses.filter(function(item) {
        return item.id === $scope.goodCid;
      })[0].good_score = $scope.goodScore;
    };

    $scope.changePassScore = function() {
      $scope.courses.filter(function(item) {
        return item.id === $scope.passCid;
      })[0].pass_score = $scope.passScore;
    };

    var dataList = [];
    $scope.loadData = function(tabCid) {
      if (!$scope.type) return;
      if ($scope.rank < 1 || $scope.rank > 2000) {
        CommonFunc.showToastr({ info: '名次必须在1-2000之间', status: 0 });
        $scope.rank = 20;
        return;
      }
      $scope.startLoading();
      if ($scope.tableInstance) $scope.tableInstance.destroy();
      $scope.list = [];
      $scope.templateUrl = 'views/result/' + $scope.type + '.html';

      if (tabCid) {
        $scope.tabCid = tabCid;
      } else if ($scope.courses && $scope.courses.length > 0) {
        $scope.tabCid = $scope.courses[0].id;
      }

      if ($scope.role.role_courseid > 0) {
        $scope.courses = $scope.meta.courses.filter(function(item) {
          return item.name === $scope.role.role_course;
        });
      } else {
        $scope.courses = $scope.meta.courses;
      }
      if ($scope.courses && $scope.courses.length > 0) {
        var graphCname = '';
        if ($scope.courses.length > 1) {
          $scope.graphCid = ($scope.courses.filter(function(item) { return item.name === '总分' }))[0].id;
          graphCname = '总分';
        } else {
          $scope.graphCid = $scope.courses[0].id;
          graphCname = $scope.courses[0].name;
        }
        $timeout(function() { $("#graphCid").dropdown("set selected", graphCname); }, 0);
        if ($scope.type === 'good' && !$scope.goodCid) {
          $scope.goodCid = $scope.graphCid;
          $timeout(function() { $("#goodCid").dropdown("set selected", graphCname); }, 0);
          $scope.changeGoodCid();
        } else if ($scope.type === 'pass' && !$scope.passCid) {
          $scope.passCid = $scope.graphCid;
          $timeout(function() { $("#passCid").dropdown("set selected", graphCname); }, 0);
          $scope.changePassCid();
        }
      }

      var params = {
        testId: $scope.testId,
        roleId: $scope.role.role_id,
        type: $scope.type,
        group: $scope.group,
        groupby: $scope.groupby,
        filterKey: $scope.filterKey !== 'none' ? $scope.filterKey : '',
        filterValue: $scope.filterValue,
        cid: $scope.tabCid,
        rank: $scope.rank
      };

      if (params.type === 'good' || params.type === 'pass') {
        params.score = $scope.courses.map(function(item) {
          return params.type === 'good' ? item.good_score : item.pass_score;
        });
      }

      resApi.getTeacherResult(params).$promise.then(function(ret) {
        $scope.order = '';
        $scope.orderReverse = true;
        if ($scope.type === 'levelscore') $scope.levelScores = ret.data.scores;
        if ($scope.type === 'option') $scope.letters = ret.data.letters;
        if ($scope.type === 'quality_score') {
          $scope.qualityDateHeaders = ret.data.dateHeader;
          $scope.qualityDateList = ret.data.listDate;
          $scope.qualityHeaders = ret.data.header;
        } 
        dataList = ret.data.list;
        $scope.total = dataList.length;
        $scope.page = 1;
        if ($scope.type === 'note') {
          $scope.list = ret.data.list;
          setTrustedList($scope.list);
        } else {
          setQuestions();
          setUnitList();
          setInitUnit();
          setList();
          $timeout(function() {
            loadChart();
          }, 0);
        }
        if (ret.status === 0) CommonFunc.showToastr(ret);
        $scope.stopLoading();
      });
    }

    $scope.changePage = function(page) {
      if (page === '...') return;
      if (page < 1) return;
      if (page > $scope.totalPage) return;
      $scope.page = page;
      setList();
    };

    $scope.changeLimit = function(limit) {
      $scope.page = 1;
      setList();
    };

    $scope.changeGraphCid = function() {
      loadChart();
    };

    $scope.changeGraphQid = function() {
      loadChart();
    };

    $scope.onChangeQualityScoreType = function(type) {
      $scope.qualityScoreType = type;
    };

    function setQuestions() {
      var questions = [];
      $scope.graphQid = '';
      if ($scope.type === 'option') {
        questions = dataList.filter(function(item) {
          return item.optionnum > 0 && !item.handwrite;
        });
        if (questions.length > 0) {
          $scope.graphQid = questions[0].qid;
          $timeout(function() {
            var label = '第' + questions[0].name + '题（答案：' + questions[0].answer + '）';
            $("#graphQid").dropdown("set selected", label);
          }, 0);
        }
      }
      $scope.questions = questions;
    }

    function setUnitList() {
      var units = [];
      if ($scope.type !== 'score' && $scope.type !== 'topN' && $scope.type !== 'note') {
        dataList.forEach(function(row) {
          var unit = getRowUnit(row);
          if (unit && units.indexOf(unit) === -1) {
            units.push(unit);
          }
        });
      }
      $scope.unitList = units;
    }

    function getRowUnit(row) {
      if ($scope.groupby === 'class') {
        return row.unit === '总体' ? '总体' : row.school + ' ' + row.unit + '班';
      } else {
        return row.unit;
      }
    }

    function _setSelect(dropdownId, val) {
      $timeout(function() {
        $(dropdownId).dropdown("set selected", val);
      }, 0);
    }

    function setInitUnit() {
      var units = $scope.unitList;
      var currentUnit = '';
      var compareUnit = '';

      if ($scope.role.mt_unittype == 0 && ($scope.groupby === 'school' || $scope.groupby === 'school_all')) {
        currentUnit = $scope.role.school_name;
        var otherSchools = units.filter(function(item) {
          return item !== school;
        });
        if (otherSchools.length) compareUnit = otherSchools[0];
      } else {
        if (units.length) currentUnit = units[0];
        if (units.length > 1) compareUnit = units[1];
      }
      if (currentUnit) {
        _setSelect('#currentUnit', currentUnit);
      }
      if (compareUnit) {
        _setSelect('#compareUnit', compareUnit);
      }
      $scope.currentUnit = currentUnit;
      $scope.compareUnit = compareUnit;
    }

    function setList() {
      var page = $scope.page;
      var limit = $scope.limit;
      var totalPage = limit > 0 ? Math.ceil($scope.total / limit) : 0;
      var start = (page - 1) * limit;
      var end = limit > 0 ? page * limit : $scope.total;
      var pagination = [];
      if (totalPage > 7) {
        if (page - 3 > 0) {
          pagination.push(1);
        }
        if (page - 4 > 0) {
          pagination.push('...');
        }
        var pageStart = page - 2 > 0 ? page - 2 : 1;
        var pageEnd;
        if (pageStart + 4 < totalPage) {
          pageEnd = pageStart + 4;
        } else {
          pageEnd = totalPage;
          pageStart = totalPage - 4;
        }
        for (var i = pageStart; i < pageEnd + 1; i++) {
          pagination.push(i);
        }
        if (page + 4 < totalPage + 1) {
          pagination.push('...');
        }
        if (page + 3 < totalPage + 1) {
          pagination.push(totalPage);
        }
      } else {
        for (var i = 1; i < totalPage + 1; i++) {
          pagination.push(i);
        }
      }
      $scope.totalPage = totalPage;
      $scope.list = dataList.slice(start, end);
      $scope.pagination = pagination;
    }

    function setTrustedList(list) {
      if (!list) return;
      for (var index = 0; index < $scope.courses.length; index++) {
        var cid = $scope.courses[index].id;
        var noteList = list[cid];
        if (noteList && noteList.length > 0) {
          for (var i = 0; i < noteList.length; i++) {
            list[cid][i].note = $sce.trustAsHtml(noteList[i].note || '暂无解析');
          }
        }
      }
    }

    $scope.export = function() {
      if (!$scope.type || $scope.type === 'note') return;
      if (device.mobile()) {
        $('#modal-download').modal('show');
      } else {
        var fields = ['testId', 'type', 'groupby', 'filterKey', 'filterValue', 'rank'];
        var params = ['export=1&roleId=' + $scope.role.role_id];
        for (var i = 0; i < fields.length; i++) {
          params.push(fields[i] + '=' + $scope[fields[i]]);
        }
        params.push('cid=' + $scope.tabCid);
        var url = BASE_URL + 'teacherResult?' + params.join('&');
        window.open(url);
      }
    }

    function _resetFilter() {
      var selVal = '';
      $scope.filterKey = $scope.filterTypeList.length ? $scope.filterTypeList[0].key : '';
      $scope.filterValue = '';
      if (!$scope.type) return;
      if ($scope.type === 'score' || $scope.type === 'quality_record' || $scope.type === 'quality_score' || $scope.type === 'compare') {
        // 成绩单查询时，过滤条件为班级
        $scope.filterKey = 'class';
        $scope.filterValueList = $scope.meta.classes.filter(function(item) {
          return item.school === $scope.school;
        });
        $scope.filterValue = $scope.filterValueList[0].key;
        selVal = $scope.filterValueList[0].val;
        $scope.quality_class = $scope.filterValue;
        $timeout(function() {
          $("#qs_class").dropdown("set selected", selVal);
        }, 0);
        $scope.onChangeQualityClass();
      } else {
        $scope.filterKey = 'none';
        $timeout(function() {
          $("#filterKey").dropdown("set selected", 'none');
        }, 0);
      }

      $timeout(function() {
        $("#filterValue").dropdown("set selected", selVal);
      }, 0);
    }

    $scope.changeRole = function() {
      $scope.type = "";
      _setGroupBy('class');
      setMenuList();
    };

    $scope.changeMenu = function() {
      var type = $scope.type;
      $scope.typeName = $scope.menuList.filter(function(item) {
        return item.rt_key === type;
      })[0].rt_name;
      var groupby = '';
      if ($scope.role.role_level < 15 && $scope.groupTypes.indexOf(type) >= 0) {
        if (type === 'distribution' || type === 'quality') {
          groupby = 'all';
        } else {
          if ($scope.filterTypeList.length) {
            groupby = $scope.filterTypeList[0].value;
          } else {
            groupby = 'class';
          }
        }
      }
      _setGroupBy(groupby);
      _resetFilter();
      $scope.loadData();
    };

    function _setGroupBy(type) {
      $scope.groupby = type;
      $timeout(function() { $("#groupby").dropdown("set selected", type); }, 0);
    }

    $scope.changeClass = function() {
      $scope.loadData();
    };

    $scope.changeCourse = function() {
      $scope.loadData();
    };

    $scope.changeGroupBy = function() {
      _resetFilter();
      $scope.loadData();
    };

    $scope.changeFilterKey = function() {
      if ($scope.type === 'score' || $scope.type === 'quality_record' || $scope.type === 'quality_score') return;
      var lastFilterValue = $scope.filterValue;
      $scope.filterValueList = [{ key: '', val: '全部' }].concat($scope.meta.filterValue[$scope.filterKey]);
      $scope.filterValue = $scope.filterValueList[0].key;
      selVal = $scope.filterValueList[0].val;
      if (lastFilterValue) $scope.loadData();
      $timeout(function() {
        $("#filterValue").dropdown("set selected", selVal);
      }, 0);
    };

    $scope.changeFilterValue = function() {
      $scope.loadData();
    };

    $scope.print = function() {
      if ($scope.role.role_courseid > 0) {
        $("#print-type").val('course');
        $("#print-cid").val($scope.role.role_courseid);
      } else {
        $("#print-type").val('student');
        $("#print-cid").val('');
      }
      $("#print-classname").val($("#print-classname").val().split('|')[1]);
      $("#print-whereclass").val($("#print-whereclass").val().split('|')[1]);
      $("#print-form").submit();
    };

    function setMenuList() {
      $scope.menuList = $scope.menus.filter(function(item) {
        return isShow(item);
      });
      $scope.type = $scope.menuList[0].rt_key;
      $timeout(function() { $("#type").dropdown("set selected", $scope.menuList[0].rt_name); }, 0);
      $scope.typeName = $scope.menuList[0].rt_name;
      _resetFilter();
      $scope.loadData();
    }

    function isShow(menu) {
      var role = $scope.role;
      if (role.role_courseid > 0) {
        return menu.rt_iscourse == 1;
      } else if (role.role_level <= 14) {
        return menu.rt_level == 1 && menu.rt_iscourse == 0;
      } else {
        return menu.rt_level == 1 && menu.rt_iscourse == 0;
      }
    }

    $scope.submitPrintScore = function() {
      $scope.printSubmitted = true;
      if ($scope.ngPrintForm.$valid) {
        console.log($scope.printParams);
        $("#print-form").submit();
      }
    };

    $scope.hideModalPrint = function () {
      $('#modal-print-score').modal('hide');
    };

    $scope.changeOrder = function(order) {
      if (order === $scope.order) $scope.orderReverse = !$scope.orderReverse;
      $scope.order = order;
      $('.tbody').scrollTop(0);
    };

    $scope.addQuality = function () {
      $scope.isEditQuality = false;
      $('#modal-quality-score').modal('show');
    };

    $scope.renderBehavior = function(record) {
      var label = record.quality_behavior + ' (' + record.quality_type + ')';
      // var quality_score = record.quality_score > 0 ? ('+' + record.quality_score) : record.quality_score;
      // var label = record.quality_behavior + ' (' + record.quality_type + ' ' + quality_score + ')';
      return label;
    };

    $scope.editQuality = function(row) {
      $scope.isEditQuality = true;
      $('#modal-quality-score').modal('show');
      $scope.qualityParams.testnumber = row.testnumber;
      $scope.qualityParams.qualityid = row.quality_id;
      $scope.qualityParams.desc = row.qs_desc;
      $scope.qualityParams.qs_id = row.qs_id;

      $scope.quality_category = row.quality_category;
      $scope.quality_scene = row.quality_scene;
      fetchQualityMenu(row.quality_category);
      $scope.onChangeQualityCategory(row.quality_scene);
      $scope.onChangeQualityScene(row.quality_behavior);

      var classname = row.school + '|' + row.class;
      $scope.quality_class = classname;
      if($scope.filterValueList.length) {
        var classData = $scope.filterValueList.find(function(item) {
          return item.key === classname;
        });
        $timeout(function() {
          $("#qs_class").dropdown("set selected", classData.val);
        }, 0);
      }
      $scope.onChangeQualityClass(row.testnumber);
    };

    $scope.submitQuality = function(hideModal) {
      if ($scope.ngQualityForm.$valid) {
        var method = $scope.isEditQuality ? 'updateQuality' : 'addQuality';
        resApi[method]($scope.qualityParams).$promise.then(function(ret) {
          if(ret.status === 1) {
            if(hideModal) $scope.hideModalQuality();
          }
          CommonFunc.showToastr(ret);
          $scope.loadData();
        });
      }
    };

    $scope.deleteQuality = function(row) {
      resApi.deleteQuality({qualityid: row.qs_id}).$promise.then(function(ret) {
        CommonFunc.showToastr(ret);
        $scope.loadData();
      });
    };

    $scope.hideModalQuality = function() {
      $('#modal-quality-score').modal('hide');
    };

    $scope.onChangeQualityCategory = function(scene) {
      var category = $scope.quality_category;
      resApi.getQualityMenu({type: 'scene', key: category}).$promise.then(function(ret) {
        $scope.qualitySceneList = ret.data;
        var data = scene ? ret.data.find(function(item) {
          return item === scene;
        }) : ret.data[0];
        $scope.quality_scene = data;
        $timeout(function() {
          $("#quality_scene").dropdown("set selected", data);
        }, 0);
        if(!scene) $scope.onChangeQualityScene();
      });
    };

    $scope.onChangeQualityScene = function(behavior) {
      var scene = $scope.quality_scene;
      var category = $scope.quality_category;
      resApi.getQualityMenu({type: 'behavior', category: category,  key: scene}).$promise.then(function(ret) {
        $scope.qualityBehaviorList = ret.data;
        var data = behavior ? ret.data.find(function(item) {
          return item.quality_behavior === behavior;
        }) : ret.data[0];
        $scope.qualityParams.qualityid = data.quality_id;
        var label = $scope.renderBehavior(data);
        $timeout(function() {
          $("#quality_behavior").dropdown("set selected", label);
        }, 0);
      });
    };

    function fetchQualityMenu(category) {
      resApi.getQualityMenu().$promise.then(function(ret) {
        if(!ret.data.length) return;
        $scope.qualityCategoryList = ret.data;
        var data = category ? ret.data.find(function(item) {
          return item === category;
        }) : ret.data[0];
        $scope.quality_category = data;
        $timeout(function() {
          $("#quality_category").dropdown("set selected", data);
        }, 0);
        if(!category) $scope.onChangeQualityCategory();
      });
    }

    $scope.onChangeQualityClass = function(testnumber) {
      var classname = $scope.quality_class;
      resApi.getStudentByClass({
        class: classname, 
        testid: $scope.testId
      }).$promise.then(function(ret) {
        var list = ret.data || [];
        $scope.qualityStudentList = list;
        var data = testnumber ? list.find(function(item) {
          return item.testnumber === testnumber;
        }) : list[0];
        $scope.qualityParams.testnumber = data.testnumber;
        $timeout(function() {
          $("#qs_testnumber").dropdown("set selected", data.testnumber + ' ' + data.name);
        }, 0);
      });
    };

    // 设置全屏和非全屏状态下的表格高度
    function _setTableHeight() {
      $timeout(function() {
        var windowHeight = $(window).height();
        // $scope.fullViewHeight = (windowHeight - 205 - 24) + 'px';
        // $scope.normalHeight = (windowHeight - 205 - 76 - 24) + 'px';
        $scope.fullViewHeight = 'auto';
        $scope.normalHeight = 'auto';
      }, 0);
    }
    _setTableHeight();

    $(window).on('resize', function() {
      _setTableHeight();
    });
  }
]);

app.controller('DetailResult', ['$scope', '$location', 'resApi', 'CommonFunc', '$route', '$timeout', '$routeParams', '$sce',
  function($scope, $location, resApi, CommonFunc, $route, $timeout, $routeParams, $sce) {
    $scope.data = {};
    $scope.testId = $routeParams.testId;
    var roleId = $location.search().role;
    $scope.school = $location.search().school;
    
    // 控制弹窗的显示/隐藏，用于 DOM 的创建和销毁
    $scope.showPaperModal = false;

    $scope.startLoading();
    resApi.detailResult({
      testId: $routeParams.testId,
      testnumber: $routeParams.testnumber,
      roleId: roleId
    }).$promise.then(function(ret) {
      $scope.stopLoading();
      $scope.data = ret.data;
      if (ret.status === 0) {
        CommonFunc.showToastr(ret);
        return;
      }
      if ($scope.data.courses) {
        $scope.data.courses.pop();
        $scope.courseId = $scope.data.courses[0].id;
      } else {
        $scope.courseId = ret.data.cid;
      }

      $scope.setCrumb([{
        title: '成绩单列表',
        path: '/tests'
      }, {
        title: $scope.data.test.testtitle,
        path: '/teacherresult/' + $scope.testId,
      }, {
        title: $scope.data.student.name + '的成绩单'
      }]);

      $timeout(function() { $('.ui.dropdown').dropdown(); }, 0);
    });

    $scope.showModalPaper = function(url, row) {
      $scope.paperSrc = url;
      
      // 如果 URL 为空，清空所有相关数据
      if (!url) {
        $scope.paperScoreInfo = {
          fullScore: '-',
          myScore: '-',
          objectiveScore: '-',
          subjectiveScore: '-'
        };
        $scope.paperAreas = [];
        $scope.objectiveOptions = [];
        $scope.objectiveMarks = [];
        return;
      }
      
      // 计算试卷成绩信息
      if (row && $scope.data.questions) {
        var pid = row.pid;
        var cid = row.cid;
        
        // 筛选出当前科目的所有小题
        var questions = $scope.data.questions.filter(function(q) {
          return q.pid === pid && q.cid === cid;
        });
        
        // 计算各项成绩
        var fullScore = 0;        // 卷面满分
        var myScore = 0;          // 我的成绩
        var objectiveScore = 0;   // 客观题得分
        var subjectiveScore = 0;  // 主观题得分
        
        questions.forEach(function(q) {
          fullScore += parseFloat(q.fullscore) || 0;
          myScore += parseFloat(q.score) || 0;
          
          // 根据optionnum判断是客观题还是主观题
          if (parseInt(q.optionnum) > 0) {
            objectiveScore += parseFloat(q.score) || 0;
          } else {
            subjectiveScore += parseFloat(q.score) || 0;
          }
        });
        
        // 格式化分数：去掉末尾的.0
        var formatScore = function(score) {
          var formatted = score.toFixed(1);
          return formatted.replace(/\.0$/, '');
        };
        
        // 设置paperScoreInfo
        $scope.paperScoreInfo = {
          fullScore: formatScore(fullScore),
          myScore: formatScore(myScore),
          objectiveScore: formatScore(objectiveScore),
          subjectiveScore: formatScore(subjectiveScore)
        };
        
        // 获取整个试卷下所有科目的切割区域
        $scope.paperAreas = [];
        $scope.objectiveOptions = [];
        $scope.objectiveMarks = []; // 不再显示对错符号
        
        if ($scope.data.papers) {
          // 找到当前试卷的所有科目
          var allPaperInfos = $scope.data.papers.filter(function(p) {
            return p.pid === pid;
          });
          
          // 合并所有科目的主观题切块
          var allAreas = [];
          allPaperInfos.forEach(function(paperInfo) {
            if (paperInfo.areas && paperInfo.areas.length > 0) {
              allAreas = allAreas.concat(paperInfo.areas);
            }
          });
          
          if (allAreas.length > 0) {
            // 按照 groupid 去重（同一个 groupid 的切块区域是相同的）
            var seenGroupIds = {};
            var uniqueAreas = [];
            allAreas.forEach(function(area) {
              if (!seenGroupIds[area.groupid]) {
                seenGroupIds[area.groupid] = true;
                uniqueAreas.push(area);
              }
            });
            
            // 处理相交区域，避免重叠
            var adjustedAreas = $scope.adjustOverlappingAreas(uniqueAreas);

            console.log(adjustedAreas);
            
            // 为每个区域附加小题得分信息（不限制科目）
            $scope.paperAreas = adjustedAreas.map(function(area) {
              var areaWithScores = angular.copy(area);
              // 兼容旧接口；新接口返回空数组时不回退到旧教师字段。
              if (!angular.isArray(areaWithScores.teachers)) {
                areaWithScores.teachers = areaWithScores.teacherName || areaWithScores.teacherPhone ? [{
                  name: areaWithScores.teacherName || '',
                  phone: areaWithScores.teacherPhone || ''
                }] : [];
              }
              areaWithScores.questionScores = $scope.getQuestionScoresForGroup(area.groupid, pid, null);
              return areaWithScores;
            });
          }
          
          // 处理客观题选项识别区（使用当前科目的paperInfo获取偏移值）
          var currentPaperInfo = allPaperInfos.find(function(p) {
            return p.cid === cid;
          });
          
          if (currentPaperInfo && currentPaperInfo.objectiveGroups) {
            var optionsData = $scope.getObjectiveOptions(currentPaperInfo, pid, cid);
            $scope.objectiveOptions = optionsData.options;
            // $scope.objectiveMarks = optionsData.marks; // 不再显示对错符号
          }
        }
      } else {
        // 如果没有数据，设置为默认值
        $scope.paperScoreInfo = {
          fullScore: '-',
          myScore: '-',
          objectiveScore: '-',
          subjectiveScore: '-'
        };
        $scope.paperAreas = [];
      }
      
      // 设置标志以创建弹窗 DOM
      $scope.showPaperModal = true;
      
      // 等待 DOM 创建完成后打开弹窗
      $timeout(function() { 
        $('#modal-paper').modal({
          onHidden: function() {
            // 弹窗关闭后销毁 DOM
            $scope.$apply(function() {
              $scope.closePaperModal();
            });
          }
        }).modal('show'); 
      }, 0);
    };

    // 关闭并销毁弹窗
    $scope.closePaperModal = function() {
      $scope.showPaperModal = false;
      // 清空数据
      $scope.paperSrc = '';
      $scope.paperScoreInfo = {
        fullScore: '-',
        myScore: '-',
        objectiveScore: '-',
        subjectiveScore: '-'
      };
      $scope.paperAreas = [];
      $scope.objectiveOptions = [];
      $scope.objectiveMarks = [];
    };

    // 获取客观题选项识别区
    $scope.getObjectiveOptions = function(paperInfo, pid, cid) {
      if (!paperInfo.objectiveGroups || !$scope.data.questions) {
        return { options: [], marks: [] };
      }
      
      var options = [];
      var marks = [];
      var xdiff = paperInfo.xdiff || 0;
      var ydiff = paperInfo.ydiff || 0;
      
      // 获取当前试卷下所有科目的所有客观题，并按id排序
      var allObjectiveQuestions = $scope.data.questions.filter(function(q) {
        return q.pid === pid && parseInt(q.optionnum) > 0;
      }).sort(function(a, b) {
        return parseInt(a.qid) - parseInt(b.qid);
      });
      
      // 按顺序遍历每个模板题组，从客观题列表中顺序取出对应数量的小题
      var questionIndex = 0;
      paperInfo.objectiveGroups.forEach(function(group) {
        var groupItems = parseInt(group.items);
        
        // 从当前位置开始，取出 groupItems 个小题
        for (var qIndex = 0; qIndex < groupItems && questionIndex < allObjectiveQuestions.length; qIndex++, questionIndex++) {
          var question = allObjectiveQuestions[questionIndex];
          var studentAnswer = question.answer || '';
          var correctAnswer = question.qAnswer || '';
          var isCorrect = studentAnswer === correctAnswer;
          
          // 将学生答案和正确答案转为数组（可能是多选）
          var selectedOptions = studentAnswer.split('').filter(function(c) { return c && c !== '_'; });
          var correctOptions = correctAnswer.split('').filter(function(c) { return c && c !== '_'; });
          
          // 计算第一个选项的位置，用于放置对错标记
          var firstOptionRect = $scope.calculateOptionRect(group, qIndex, 0, xdiff, ydiff);
          var markPosition = $scope.calculateMarkPosition(group, firstOptionRect);
          marks.push({
            isCorrect: isCorrect,
            questionName: question.name,
            position: markPosition
          });
          
          // 计算选项位置
          var optionCount = parseInt(question.optionnum);
          for (var i = 0; i < optionCount; i++) {
            var optionChar = String.fromCharCode(65 + i); // A, B, C, D...
            var isSelected = selectedOptions.indexOf(optionChar) >= 0;
            var isCorrectOption = correctOptions.indexOf(optionChar) >= 0;
            
            // 渲染学生选择的选项
            if (isSelected) {
              var rect = $scope.calculateOptionRect(group, qIndex, i, xdiff, ydiff);
              options.push({
                rect: rect,
                isCorrect: isCorrect,
                isCorrectAnswer: false,
                questionName: question.name,
                optionChar: optionChar
              });
            }
            
            // 如果答错了，还要渲染正确答案选项（绿色）
            if (!isCorrect && isCorrectOption) {
              var rectCorrect = $scope.calculateOptionRect(group, qIndex, i, xdiff, ydiff);
              options.push({
                rect: rectCorrect,
                isCorrect: false,
                isCorrectAnswer: true,
                questionName: question.name,
                optionChar: optionChar
              });
            }
          }
        }
      });
      
      return { options: options, marks: marks };
    };
    
    // 计算对错标记的位置
    $scope.calculateMarkPosition = function(group, firstOptionRect) {
      var isHorizontal = group.direction === '0';
      var markSize = 20; // 标记的大小
      var offset = 5; // 与选项的间距
      
      var x, y;
      if (isHorizontal) {
        // 横向排列：标记在第一个选项的左侧
        x = firstOptionRect.x - markSize - offset;
        y = firstOptionRect.y + (firstOptionRect.height - markSize) / 2; // 垂直居中
      } else {
        // 纵向排列：标记在第一个选项的上方
        x = firstOptionRect.x + (firstOptionRect.width - markSize) / 2; // 水平居中
        y = firstOptionRect.y - markSize - offset;
      }
      
      return {
        x: x,
        y: y,
        size: markSize
      };
    };

    // 计算单个选项的矩形位置
    $scope.calculateOptionRect = function(group, itemIndex, optionIndex, xdiff, ydiff) {
      var isHorizontal = group.direction === '0';
      var items = group.items;
      var options = group.options;
      var groupWidth = group.width;
      var groupHeight = group.height;
      
      // 计算选项宽高
      var optionWidth, optionHeight;
      if (group.optionWidth > 0 && group.optionHeight > 0) {
        // 使用手动设置的选项宽高
        optionWidth = group.optionWidth;
        optionHeight = group.optionHeight;
      } else {
        // 自动计算选项宽高
        if (isHorizontal) {
          optionWidth = groupWidth / ((1.5 * options) - 0.5);
          optionHeight = groupHeight / ((1.5 * items) - 0.5);
        } else {
          optionWidth = groupWidth / ((1.5 * items) - 0.5);
          optionHeight = groupHeight / ((1.5 * options) - 0.5);
        }
      }
      
      // 计算间距
      var wSpace, hSpace;
      if (isHorizontal) {
        wSpace = options > 1 ? (groupWidth - options * optionWidth) / (options - 1) : 0;
        hSpace = items > 1 ? (groupHeight - items * optionHeight) / (items - 1) : 0;
      } else {
        wSpace = items > 1 ? (groupWidth - items * optionWidth) / (items - 1) : 0;
        hSpace = options > 1 ? (groupHeight - options * optionHeight) / (options - 1) : 0;
      }
      
      // 计算当前选项的位置
      var x, y;
      if (isHorizontal) {
        // 横向：选项横向排列，小题纵向排列
        x = group.x + optionIndex * (optionWidth + wSpace);
        y = group.y + itemIndex * (optionHeight + hSpace);
      } else {
        // 纵向：小题横向排列，选项纵向排列
        x = group.x + itemIndex * (optionWidth + wSpace);
        y = group.y + optionIndex * (optionHeight + hSpace);
      }
      
      return {
        x: x + xdiff,
        y: y + ydiff,
        width: optionWidth,
        height: optionHeight
      };
    };

    // 获取题组下的小题得分信息
    $scope.getQuestionScoresForGroup = function(groupid, pid, cid) {
      if (!$scope.data.questions || !groupid) {
        return [];
      }
      
      // 筛选出属于该题组的小题
      // 如果 cid 为 null，则不限制科目，获取整个试卷下该题组的所有小题
      var groupQuestions = $scope.data.questions.filter(function(q) {
        if (cid === null) {
          return q.pid === pid && parseInt(q.groupid) === parseInt(groupid);
        } else {
          return q.pid === pid && q.cid === cid && parseInt(q.groupid) === parseInt(groupid);
        }
      });
      
      // 按小题id排序
      groupQuestions.sort(function(a, b) {
        return parseInt(a.qid) - parseInt(b.qid);
      });
      
      // 格式化返回数据
      return groupQuestions.map(function(q) {
        var score = parseFloat(q.score) || 0;
        var formattedScore = score.toFixed(1).replace(/\.0$/, '');
        return {
          name: q.name,
          score: formattedScore
        };
      });
    };

    // 调整重叠的切割区域
    $scope.adjustOverlappingAreas = function(areas) {
      if (!areas || areas.length <= 1) {
        return areas;
      }
      
      // 深拷贝区域数组，避免修改原始数据
      var adjustedAreas = areas.map(function(area) {
        var adjustedArea = angular.copy(area);
        adjustedArea.x = parseFloat(area.x);
        adjustedArea.y = parseFloat(area.y);
        adjustedArea.x2 = parseFloat(area.x2);
        adjustedArea.y2 = parseFloat(area.y2);
        return adjustedArea;
      });
      
      // 检查所有区域对，处理相交情况
      for (var i = 0; i < adjustedAreas.length; i++) {
        for (var j = i + 1; j < adjustedAreas.length; j++) {
          var areaA = adjustedAreas[i];
          var areaB = adjustedAreas[j];
          
          // 检查两个区域是否相交
          if ($scope.isRectIntersect(areaA, areaB)) {
            // 计算相交区域
            var intersect = {
              x: Math.max(areaA.x, areaB.x),
              y: Math.max(areaA.y, areaB.y),
              x2: Math.min(areaA.x2, areaB.x2),
              y2: Math.min(areaA.y2, areaB.y2)
            };
            
            var intersectWidth = intersect.x2 - intersect.x;
            var intersectHeight = intersect.y2 - intersect.y;
            
            // 根据相交区域的形状决定分割方向
            if (intersectWidth > intersectHeight) {
              // 水平重叠较多，沿垂直方向分割（调整上下边界）
              var midY = (intersect.y + intersect.y2) / 2;
              
              // 判断哪个区域在上方
              if (areaA.y < areaB.y) {
                // A在上，B在下
                if (areaA.y2 > midY) areaA.y2 = midY;
                if (areaB.y < midY) areaB.y = midY;
              } else {
                // B在上，A在下
                if (areaB.y2 > midY) areaB.y2 = midY;
                if (areaA.y < midY) areaA.y = midY;
              }
            } else {
              // 垂直重叠较多，沿水平方向分割（调整左右边界）
              var midX = (intersect.x + intersect.x2) / 2;
              
              // 判断哪个区域在左侧
              if (areaA.x < areaB.x) {
                // A在左，B在右
                if (areaA.x2 > midX) areaA.x2 = midX;
                if (areaB.x < midX) areaB.x = midX;
              } else {
                // B在左，A在右
                if (areaB.x2 > midX) areaB.x2 = midX;
                if (areaA.x < midX) areaA.x = midX;
              }
            }
          }
        }
      }
      
      return adjustedAreas;
    };
    
    // 判断两个矩形是否相交
    $scope.isRectIntersect = function(rectA, rectB) {
      return !(rectA.x2 <= rectB.x || 
               rectA.x >= rectB.x2 || 
               rectA.y2 <= rectB.y || 
               rectA.y >= rectB.y2);
    };

    // 计算对错标记的样式
    $scope.getMarkStyle = function(mark) {
      var img = document.getElementById('paper-image');
      if (!img || !img.naturalWidth) {
        return {};
      }
      
      // 获取图片的原始尺寸和实际显示尺寸
      var naturalWidth = img.naturalWidth;
      var naturalHeight = img.naturalHeight;
      var displayWidth = img.offsetWidth;
      var displayHeight = img.offsetHeight;
      
      // 计算缩放比例
      var scaleX = displayWidth / naturalWidth;
      var scaleY = displayHeight / naturalHeight;
      
      // 计算标记的位置和大小
      var left = mark.position.x * scaleX;
      var top = mark.position.y * scaleY;
      var size = mark.position.size * Math.min(scaleX, scaleY);
      
      return {
        'position': 'absolute',
        'left': left + 'px',
        'top': top + 'px',
        'width': size + 'px',
        'height': size + 'px',
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'font-size': (size * 0.8) + 'px',
        'font-weight': 'bold',
        'color': mark.isCorrect ? 'green' : 'red',
        'pointer-events': 'none',
        'z-index': '7'
      };
    };

    // 计算客观题选项的样式
    $scope.getObjectiveOptionStyle = function(option) {
      var img = document.getElementById('paper-image');
      if (!img || !img.naturalWidth) {
        return {};
      }
      
      // 获取图片的原始尺寸和实际显示尺寸
      var naturalWidth = img.naturalWidth;
      var naturalHeight = img.naturalHeight;
      var displayWidth = img.offsetWidth;
      var displayHeight = img.offsetHeight;
      
      // 计算缩放比例
      var scaleX = displayWidth / naturalWidth;
      var scaleY = displayHeight / naturalHeight;
      
      // 计算选项的位置和大小
      var left = option.rect.x * scaleX;
      var top = option.rect.y * scaleY;
      var width = option.rect.width * scaleX;
      var height = option.rect.height * scaleY;
      
      // 根据类型设置边框颜色
      var borderColor;
      if (option.isCorrectAnswer) {
        // 正确答案标记 - 绿色
        borderColor = 'green';
      } else if (option.isCorrect) {
        // 学生答对了 - 蓝色
        borderColor = 'blue';
      } else {
        // 学生答错了 - 红色
        borderColor = 'red';
      }
      
      return {
        'position': 'absolute',
        'left': left + 'px',
        'top': top + 'px',
        'width': width + 'px',
        'height': height + 'px',
        'border': '2px solid ' + borderColor,
        'box-sizing': 'border-box',
        'pointer-events': 'none'
      };
    };

    // 计算切割区域的样式
    $scope.getPaperAreaStyle = function(area) {
      var img = document.getElementById('paper-image');
      if (!img || !img.naturalWidth) {
        return {};
      }
      
      // 获取图片的原始尺寸和实际显示尺寸
      var naturalWidth = img.naturalWidth;
      var naturalHeight = img.naturalHeight;
      var displayWidth = img.offsetWidth;
      var displayHeight = img.offsetHeight;
      
      // 计算缩放比例
      var scaleX = displayWidth / naturalWidth;
      var scaleY = displayHeight / naturalHeight;
      
      // 计算区域的位置和大小
      var left = area.x * scaleX;
      var top = area.y * scaleY;
      var width = (area.x2 - area.x) * scaleX;
      var height = (area.y2 - area.y) * scaleY;
      
      return {
        'position': 'absolute',
        'left': left + 'px',
        'top': top + 'px',
        'width': width + 'px',
        'height': height + 'px',
        'border': '2px solid red',
        'box-sizing': 'border-box',
        'pointer-events': 'none'
      };
    };

    // 图片操作相关方法
    $scope.onPaperImageLoad = function() {
      $timeout(function() {
        $scope.restorePaperImage();
        // 触发 Angular 的 digest 循环以重新计算样式
        $scope.$apply();
      }, 100);
    };

    $scope.restorePaperImage = function() {
      var img = document.getElementById('paper-image');
      if (!img) return;
      
      // 重置尺寸以获取原始大小
      img.style.width = '';
      img.style.height = '';
      
      // 获取图片的自然尺寸
      var naturalWidth = img.naturalWidth;
      var naturalHeight = img.naturalHeight;
      
      // 设置为原始大小的 50%
      img.style.width = (naturalWidth * 0.5) + 'px';
      img.style.height = (naturalHeight * 0.5) + 'px';
      
      // 触发重绘
      $timeout(function() {
        $scope.$apply();
      }, 50);
    };

    $scope.zoomInPaperImage = function() {
      var img = document.getElementById('paper-image');
      if (!img) return;
      
      var currentWidth = img.offsetWidth;
      var currentHeight = img.offsetHeight;
      
      img.style.width = (currentWidth * 1.2) + 'px';
      img.style.height = (currentHeight * 1.2) + 'px';
      
      // 触发重绘
      $timeout(function() {
        $scope.$apply();
      }, 50);
    };

    $scope.zoomOutPaperImage = function() {
      var img = document.getElementById('paper-image');
      if (!img) return;
      
      var currentWidth = img.offsetWidth;
      var currentHeight = img.offsetHeight;
      
      img.style.width = (currentWidth * 0.8) + 'px';
      img.style.height = (currentHeight * 0.8) + 'px';
      
      // 触发重绘
      $timeout(function() {
        $scope.$apply();
      }, 50);
    };
  }
]);
